const a = {
  s0289cd9e4bcf84c5: "Nível de volume",
  s061cc20e3432dead: "Pausar",
  s0622a6e6cb77254b: "Transcrição",
  s080d032fc1b87b3f: "Descrição de áudio",
  s08b06007b5567108: "de",
  s08e6bd98452e6bb9: "Áudio",
  s1b4a36fce2456660: "Família de fontes",
  s1fa5be5a4f5d0f04: "Casual",
  s23537b5c9e7af982: "Legendas",
  s24221a89168e9d21: "Tamanho da fonte",
  s255857544a9d5ec0: "Redefinir",
  s25a858f0257e2879: "Menu Legendas",
  s2df075aface0dab8: "Compartilhar",
  s2f5d5d2d1f92de26: "Baixar o vídeo",
  s302cbb19bf9a174a: "Desligado",
  s308604b3ae13fbb5: "Reproduzindo",
  s344ea8f4939cdc98: "Cor",
  s3687049d1af562c4: "Copiar",
  s36b979e4de5152b3: "Link copiado",
  s37a9e8aec5713460: "Mais",
  s3ca1bdfa8785f808: "Sans Serif Proporcional",
  s41faaf3b4e182cc6: "A verificação de idade é necessária para acessar este conteúdo.",
  s49f06dca0feeb2f3: "Uniforme",
  s4b023aafbd8d5ac8: "Compartilhar este vídeo no",
  s4b10acae683d2978: "Tela inteira",
  s500caa88d20458d3: "Você não pode acessar este conteúdo",
  s5267658ceae3230f: "Compartilhar este vídeo",
  s5c5db15dfc3a5376: "Taxa de reprodução",
  s5e3cb80d43a34044: "Preto",
  s5e8250fb85d64c23: "Fechar",
  s669b18c6d2d9c95b: "Nenhum",
  s66d852e3c020e79e: "Opaco",
  s6a3bf589eaf72169: "Serifa monoespaçada",
  s6baf78886c99db89: "Amarelo",
  s6f59e9b81c5a47e0: "Sombra",
  s711d047dea682c1a: "Faixa de áudio",
  s7d148a08796094d2: "Erro de reprodução",
  s81a19821f3e4a3d2: "Repetir",
  s827bc70ebcb7bbc6: "Sans Serif Monoespaçado",
  s85186a61e0d55bac: "Vídeo",
  s889413eb7198ea01: "opção para desativar a legenda",
  s8e408592fd4ae43a: "Estilo de borda de texto",
  s8e985aeeca6a8166: "Branco",
  s8eafb22ebdc7e668: "Magenta",
  s9559a51a63cbb5fd: "Letras minúsculas",
  s95bc8722b2708f8b: "Pausado",
  s973b83fb67a5865d: "Baixar a transcrição",
  s9b3c2f9cc32d565a: "Ciano",
  s9c356016f81585f6: "Cor de fundo",
  s9d8b8aa2b404c2c8: "Configurações",
  s9fbd543f2179c1ec: "Menu Áudio",
  sa000eaf7092088c3: "Barra de progresso",
  sa6f2645578b2d2bc: "Ano",
  sa9011e79e3ca2d18: "Para baixo",
  saf9b398ab363c174: "Digite sua data de nascimento",
  sb3d4f79d9d8b71e5: "Enviar",
  sb47daaf9e1c4a905: "Mês",
  sb9f16a5f9c29f41e: "Lamentamos, mas algo deu errado.",
  sba64d8954d027206: "Opacidade",
  sc07837c309cc699b: "Desativar mudo",
  scd105819b5a10243: "Jogar",
  sce836928a17d96ed: "Cor do texto",
  scf00d78fd5953f1c: "Verde",
  sd1246235faaa3191: "Uma restrição de idade foi implementada devido a temas adultos ou requisitos legais destinados a proteger o público mais jovem.",
  sd3386a2ef42e80b9: "Baixar",
  sd8d4b1b613d28990: "Cursiva",
  sdb02f53e62c1da05: "Para cima",
  sdb73788b3c975f16: "Automático",
  se0955919920ee87d: "Dia",
  se0f67eae944f8f94: "Ativar mudo",
  se73c59cc10f48c12: "Redes sociais",
  secf3d3a7c1693e2d: "Azul",
  sed31876562d94652: "Configurações de legenda",
  sf113fa256db9617b: "Finalizado",
  sf675f879b1c892c6: "Qualidade",
  sfc24a457269b13d4: "Controle deslizante de volume",
  sfcb817633bf70e1b: "Serifa proporcional"
};
export {
  a as templates
};
